<template>
  <a-card :bordered='false'>
    <a-button type="primary" v-has:dealerCreate="()=> {$router.push('/antiFleeingGoods/documents/transferAdd')}">
      <PlusOutlined />
      创建调仓单
    </a-button>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search'  :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item class='mb15' label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.keyword_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="transfer_warehousing_sn">调仓单号</a-select-option>
            <a-select-option value="create_role_name">创建人</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="调入仓库" name='transfer_to_warehouse_id'>
        <a-select v-model:value="search.transfer_to_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="调出仓库" name='transfer_warehouse_id'>
        <a-select v-model:value="search.transfer_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="调仓单状态" name='transfer_status'>
        <a-select v-model:value="search.transfer_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">待出货</a-select-option>
          <a-select-option :value="2">调仓完成</a-select-option>
          <a-select-option :value="3">订单关闭</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='transfer_warehouse_id' :columns='columns' :data-source='data' >
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a @click="()=> {$router.push('/antiFleeingGoods/documents/transferDetails?id='+record.transfer_warehouse_id)}"
                  href="javascript:;">详情</a>
              </a-menu-item>
              <a-menu-item v-if='record.transfer_status == 1'>
                <a href="javascript:;"  @click='close(record.transfer_warehouse_id)'>关闭订单</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { PlusOutlined, DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs ,h} from "vue";
  import { message, Modal } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import { getTransferWarehousing, getWarehouseList, closeTransferWarehousing } from '@/api/antiFleeing';
  // 初始化默认筛选项数值
  let defSearch = {
    transfer_warehouse_id: '',
    transfer_to_warehouse_id:'',
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    keyword_type: "transfer_warehousing_sn",
    keyword: "",
    transfer_status:''
  };
  export default {
    components: { PlusOutlined, DownOutlined },
    setup() {
      // // 初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      // 列表数据和列头配置
      const data = ref([]);
      const state = reactive({
        listLoading: false,
        time: [],
        total: 0,
        warehouseList:[]
      });
      let columns = [
        {
          title: "调仓单号",
          dataIndex: "transfer_warehousing_sn",
          key: "transfer_warehousing_sn",
        },

        {
          title: "调出仓库",
          dataIndex: "transfer_warehouse_name",
          key: "transfer_warehouse_name",
        },
        {
          title: "调入仓库",
          dataIndex: "transfer_to_warehouse_name",
          key: "transfer_to_warehouse_name",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "创建人",
          dataIndex: "create_role_name",
          key: "create_role_name",
        },
        {
          title: "调仓单状态",
          dataIndex: "transfer_status_text",
          key: "transfer_status_text",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      // 关闭
      const close = (id) => {
        Modal.confirm({
          centered: true,
          title:'确定关闭订单？',
          content: h('div', {}, [
            h('p', '1、订单关闭后将无法开启'),
            h('p', '2、关闭订单后，商品移回原仓库，进行拆箱发货的中标和大标依然无效'),
          ]),
          onOk: async () => {
            let res = await closeTransferWarehousing(id).then((res) => res.data);
            if (iscode(res, true)) {
              initData(search.value);
            }
          },
        });
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getTransferWarehousing(values).then((res) => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        getWarehouse()
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime
      };
    },
  };
</script>